// extracted by mini-css-extract-plugin
export default {"svgCurve":"styles_svgCurve__8sdNC"};